import PetsIcon from "shared/icons/pets.svg?react";

export const NoPets = ({
  isPetScreeningVendor
}: {
  isPetScreeningVendor: boolean;
}) => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center py-20">
      <div className="p-8 rounded-full flex items-center justify-center bg-alpha-20">
        <PetsIcon className="size-10 stroke-content-300" />
      </div>
      <h2 className="text-base font-bold text-center text-content-500">
        Applicant stated they do not have any pets or assistance animals
      </h2>
      <p className="text-center text-content-300 text-sm">
        Response from
        <span className="font-bold">
          {isPetScreeningVendor ? " PetScreening" : " OurPetPolicy"}`
        </span>
      </p>
    </div>
  );
};
